var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Symbol.js
 ** module id = 45
 ** module chunks = 0
 **/